import script from "./PhoneField.vue?vue&type=script&setup=true&lang=ts"
export * from "./PhoneField.vue?vue&type=script&setup=true&lang=ts"

import "./PhoneField.vue?vue&type=style&index=0&id=0a8082fa&lang=scss"
import "./PhoneField.vue?vue&type=style&index=1&id=0a8082fa&scoped=true&lang=scss"

import exportComponent from "/var/www/twledodo-booking-minsuizenraku/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0a8082fa"]])

export default __exports__